import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CheckpointModel } from '../../checkpoint.model';
import { ChecklistModel } from '../../checklist.model';
import { FicQRAction } from '../../../../../app-cordova/app/fic-services/fic-scan-qr-code.service';

@Component({
    selector: 'fi-checkpoint-qr-code-view',
    templateUrl: './checkpoint-qr-code-view.component.html',
    styleUrls: ['./checkpoint-qr-code-view.component.scss'],
    standalone: false,
})
export class FiCheckpointQRCodeViewComponent {
    @Input() checklist: ChecklistModel;
    @Input() checkpoint: CheckpointModel;
    @Input() buttonEnabled: boolean = true;
    @Input() showCode: boolean = false;
    @Output() showCodeChange = new EventEmitter<boolean>();

    onShowCodeChange(flag: boolean) {
        this.showCode = flag;
        this.showCodeChange.emit(flag);
    }

    getQRCodeData() {
        return FicQRAction.getQRCodeForCheckpoint(this.checkpoint, this.checklist);
    }
}
